<template>
  <v-container fluid>
    <v-card>
      <v-data-table
        :headers="headers"
        :items="funds"
        sort-by="calories"
        class="elevation-1"
        :loading="loading"
        dense
        :mobile-breakpoint="0"
        :items-per-page="50"
        :footer-props="footerProps"
        :server-items-length="totalFunds"
        @update:page="changePage"
      >
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-toolbar-title>Fundos</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-layout>
              <v-chip
                :color="open ? 'primary' : 'grey'"
                :outlined="!open"
                @click="cancel ? open = !open : true"
                class="mx-1 py-1 px-2"
                small
              >Operantes</v-chip>
              <v-chip
                :color="cancel ? 'primary' : 'grey'"
                :outlined="!cancel"
                @click="open ? cancel = !cancel : true"
                class="mx-1 py-1 px-2"
                small
              >Cancelados</v-chip>
            </v-layout>
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="mdi-search"
              label="Procurar"
              class="mr-5"
              single-line
              hide-details
              @input="isTyping = true"
            ></v-text-field>
          </v-toolbar>
        </template>

        <template v-slot:item.name="{ item }">
          <router-link class="fund-link" :to="`/funds/${item._id}`">
            <span style="
                        overflow: hidden;
                        white-space: nowrap;
                        display: block;
                        text-overflow: ellipsis;">
                {{item.shortName || item.name}}
            </span>
          </router-link>
        </template>

        <template v-slot:item.manager="{ item }">
          <span style="
                      overflow: hidden;
                      white-space: nowrap;
                      display: block;
                      text-overflow: ellipsis;">
            {{item.manager ? item.manager.name : ''}}
          </span>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<style scoped>
@media (max-width: 991px) {
  .overview-row {
    flex-wrap: nowrap;
    overflow-x: scroll;
  }
}
.fund-link {
  color: #000;
  text-decoration: none;
}
</style>

<script>
import moment from 'moment-loyall';
import _ from 'lodash';
import api from '@/services/api';
import store from '@/services/store';

export default {
  data() {
    return {
      dialog: false,
      dialogLoading: false,
      funds: [],
      totalFunds: 0,
      overview: {},
      search: '',
      cancel: false,
      open: true,
      isTyping: false,
      footerProps: {
        'disable-items-per-page': true,
      },
      defaultItem: {
        name: '',
        reportName: '',
        document: '',
      },
      editedItem: {
        name: '',
        reportName: '',
        document: '',
      },
      query: '',
      loading: false,
      headers: [
        { text: 'Nome', value: 'name' },
        { text: 'Documento', value: 'document' },
        { text: 'Gestor', value: 'manager' },
      ],
    };
  },
  watch: {
    async cancel() {
      await this.getData(this.page);
    },
    async open() {
      await this.getData(this.page);
    },
    search: _.debounce(function searchWatcher() {
      this.isTyping = false;
    }, 500),
    async isTyping(value) {
      if (!value) {
        if (this.search.length === 0) {
          await this.getData();
          return;
        }
        await this.searchForm(this.search);
      }
    },
  },
  beforeMount() {
    this.getData();
  },
  methods: {
    numberWithCommas(x) {
      if (!x) return '';
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    },
    parseDate(date) {
      return moment(date).format('DD/MM/YYYY');
    },
    async changePage(page) {
      if (this.query && this.query.length > 0) {
        await this.searchForm(this.query, page);
        return;
      }
      await this.getData(page);
    },
    async getData(page = 1) {
      this.loading = true;
      this.funds = [];
      try {
        const params = {
          sortField: 'name',
          page,
        };

        if (this.cancel) {
          params.canceled = this.cancel;
        }
        const { data: responseFunds } = await api.funds.list({
          params,
        });
        this.funds = responseFunds.funds;
        this.totalFunds = responseFunds.total;
      } catch (error) {
        store.dispatch('alert/showAlert', {
          icon: 'mdi-exclamation-thick',
          iconColor: 'error',
          title: 'Ooops!',
          message: error.response ? error.response.data.error.message : error.message,
          errorList: [],
        });
      } finally {
        this.loading = false;
      }
    },
    async searchForm(query, page = 1) {
      this.query = query;
      this.funds = [];
      this.loading = true;
      let queryRest = { data: { query }, params: { page } };
      try {
        if (this.cancel !== this.open) {
          queryRest = { data: { query }, params: { page, cancel: this.cancel, open: this.open } };
        }
        const response = await api.funds.search(queryRest);
        this.funds = response.data.funds;
        this.totalFunds = response.data.total;
      } catch (error) {
        store.dispatch('alert/showAlert', {
          icon: 'mdi-exclamation-thick',
          iconColor: 'error',
          title: 'Ooops!',
          message: error.response ? error.response.data.error.message : error.message,
          errorList: [],
        });
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
